export class WebhookFormController {
    constructor($scope, $state, $stateParams, XRayUIModelSaver, WebhooksDao, TOOLTIPS, XRayUtils) {
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.xrayUtils = XRayUtils;
        this.webhooksDao = WebhooksDao;

        this.TOOLTIP = TOOLTIPS.admin.webhooks;

        $scope.$parent.Settings.showButtons = true;
        $scope.$parent.Settings.currentSubController = this;

        this.modelSaver = XRayUIModelSaver.createInstance(this,['webhookData']);
        this.modelSaver.onStateChangeCancel = () => {
            $scope.$parent.Settings.syncTabsWithState();
        };

        if (this.$stateParams.webhookName) {
            this.mode = 'edit';
            this.title = 'Edit Webhook "' + this.$stateParams.webhookName + '"';
            $scope.$parent.Settings.saveButtonText = "Save";
            this.getWebhookData();
        }
        else {
            this.mode = 'new';
            this.title = 'New Webhook';
            this.headers=[];
            $scope.$parent.Settings.saveButtonText = "Create";
        }
    }

    getWebhookData() {
        this.webhooksDao.get().$promise.then((data)=>{
            let webhook = _.find(data,{name: this.$stateParams.webhookName})
            this.headers = this.headersObjectToArray(webhook.headers);
            this.webhookData = webhook;
        })

    }

    save() {

        let payload = _.cloneDeep(this.webhookData);

        payload.headers = this.headersArrayToObject(this.headers);

        if (this.mode === 'new') {
            this.webhooksDao.create(payload).$promise.then((response)=>{
                this.modelSaver.save();
                if (response.status < 400) {
		            this.$state.go('settings.webhooks');
                }
            })
        }
        else {
            this.webhooksDao.update({name: this.webhookData.name},payload).$promise.then((response)=>{
                this.modelSaver.save();
                this.$state.go('settings.webhooks');
            })
        }
    }

    cancel() {
        this.$state.go('settings.webhooks');
    }

    canSave() {
        return this.webhookForm && this.webhookForm.$valid;
    }

    addHeader() {
        this.headers.push({key:'',value:''});
    }

    removeHeader(index) {
        this.headers.splice(index,1);
    }

    headersArrayToObject(headersArray) {
        let obj = {};
        headersArray.forEach((header)=>{
            obj[header.key] = header.value;
        });
        return obj;
    }
    headersObjectToArray(headersObject) {
        let arr = [];
        for (let key in headersObject) {
            arr.push({key: key, value: headersObject[key]});
        }
        return arr;
    }
    checkName(value) {
        return !_.includes(value,'/');
    }

	checkLocalHost(retypeVal) {

		if (typeof retypeVal !== 'undefined') {

			if (retypeVal.toLowerCase().indexOf('localhost') > -1 || retypeVal.toLowerCase().indexOf(
					'127.0.0.1') > -1) {

				return false;
			} else {

				return true;
			}
		}
		//return !retypeVal || (retypeVal && this.input.password === retypeVal);
	}

}



// WEBPACK FOOTER //
// ./modules/xray/states/settings/tabs/webhooks/webhook_form.controller.js